module.exports = __webpack_public_path__ + "img/AC_S2_Final.d14b5712.jpg";